import { Box, useMediaQuery } from "@mui/material";
import { Button, Typography, Avatar } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link as RouterLink, useParams } from "react-router-dom";
import NavbarLogin from "scenes/widgets/navbarlogin";
import Footer from "scenes/widgets/footer";
import MyPostWidget from "scenes/widgets/MyPostWidget";
import PostsWidget from "scenes/widgets/PostsWidget";
import { resolveAssetUrl } from "utils/media";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const { userId, username } = useParams();
  const currentUser = useSelector((state) => state.user);
  const token = useSelector((state) => state.token);
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");

  const getUser = async () => {
    const endpoint = username
      ? `${BASE_URL}/users/username/${username}`
      : `${BASE_URL}/users/${userId}`;
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const response = await fetch(endpoint, {
      method: "GET",
      headers,
    });
    const data = await response.json();
    setUser(data);
  };

  useEffect(() => {
    getUser();
  }, [userId, username, token]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!user || user.error) return null;

  const isOwnProfile = currentUser?._id === user._id;

  return (
    <Box>
      <NavbarLogin />
      <Box
        width="100%"
        padding="2rem 6%"
        display={isNonMobileScreens ? "flex" : "block"}
        gap="2rem"
        justifyContent="center"
      >
        <Box
          flexBasis={isNonMobileScreens ? "70%" : undefined}
          mt={isNonMobileScreens ? undefined : "2rem"}
        >
          <Box
            display="flex"
            alignItems={{ xs: "flex-start", md: "center" }}
            flexDirection={{ xs: "column", md: "row" }}
            gap={2}
            mb={2}
            p={2}
            borderRadius="12px"
            bgcolor="background.alt"
          >
            <Avatar
              src={resolveAssetUrl(user.picturePath)}
              sx={{ width: 96, height: 96 }}
            />
            <Box flex={1}>
              <Typography variant="h4">
                {user.artistName || `${user.firstName || ""} ${user.lastName || ""}`.trim() || `@${user.username || "profil"}`}
              </Typography>
              <Typography color="text.secondary" mb={0.5}>
                @{user.username}
              </Typography>
              {user.school && (
                <Typography color="text.secondary" mb={0.5}>
                  {user.school}
                </Typography>
              )}
              {isOwnProfile && (
                <Typography color="text.secondary">{user.email}</Typography>
              )}
            </Box>
            {isOwnProfile && (
              <Button component={RouterLink} to="/konto" variant="outlined">
                Profil bearbeiten
              </Button>
            )}
          </Box>
          {isOwnProfile && <MyPostWidget picturePath={user.picturePath} />}
          <Box m="2rem 0" />
          <PostsWidget userId={user._id} isProfile />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default ProfilePage;
